import { usePathname } from 'next/navigation'

export const usePromotionsBarChatView = () => {
  const pathname = usePathname()

  return pathname?.includes('/messages') || pathname?.includes('/counselling')
}
